import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerFacebookPageAnalyticsPosts.graphql';
import { Query, QueryinfluencerFacebookPageAnalyticsPostsArgs } from '../../__generated__/globalTypes';

export const useInfluencerFacebookPageAnalyticsPostsQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerFacebookPageAnalyticsPostsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerFacebookPageAnalyticsPostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerFacebookPageAnalyticsPostsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerFacebookPageAnalyticsPostsArgs>
): QueryResult<Query, QueryinfluencerFacebookPageAnalyticsPostsArgs> & {
  getInfluencerFacebookPageAnalyticsPosts: LazyQueryExecFunction<Query, QueryinfluencerFacebookPageAnalyticsPostsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerFacebookPageAnalyticsPosts, result] = useLazyQuery<
    Query,
    QueryinfluencerFacebookPageAnalyticsPostsArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerFacebookPageAnalyticsPosts, ...result };
};

export const useInfluencerFacebookPageAnalyticsPostsPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerFacebookPageAnalyticsPosts = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerFacebookPageAnalyticsPostsArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerFacebookPageAnalyticsPostsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerFacebookPageAnalyticsPosts };
};
// Suspense Query Hooks
export const useInfluencerFacebookPageAnalyticsPostsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerFacebookPageAnalyticsPostsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerFacebookPageAnalyticsPostsArgs>(QUERY, {
    ...options
  });

  return result;
};
